<template>
  <el-row>
    <el-col :span="24">
      <p>
        <b>Выберите грузополучателя из вашего списка:</b>
      </p>
      <span v-if="!isSelected" class="href-select" @click="dialogViewSet">
        Выбрать
      </span>
      <el-dialog
        title="Выбор cтивидора"
        :visible.sync="dialogView"
        width="70%"
        append-to-body
        :close-on-click-modal="false"
      >
        <select-stevedore @selected="selectStevedore" />
      </el-dialog>

      <span v-if="isSelected" class="selected-contr">
        Вы выбрали: {{ stevedore.name }}
        <span class="href-select" @click="dialogViewSet">
          Выбрать другого
        </span>
      </span>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectStevedore from './SelectStevedore'

export default {
  name: 'SetStevedore',
  components: { SelectStevedore },
  data() {
    return {
      dialogView: false,
      isSelected: false,
      id: '',
      curr: '',
      returnData: {
        name: '',
        legal_name: '',
        legal_address: '',
      },
    }
  },
  computed: {
    ...mapGetters({ getStevedore: 'stevedores/getStevedore' }),
    stevedore() {
      return this.id ? this.getStevedore(this.id) : {}
    },
  },
  methods: {
    selectStevedore(id) {
      this.dialogView = false
      this.isSelected = true
      this.id = id
      this.returnData.name = this.stevedore.name
      this.returnData.legal_name = this.stevedore.legal_name
      this.returnData.legal_address = this.stevedore.legal_address
      this.$emit('changed', this.returnData)
    },
    dialogViewSet() {
      this.dialogView = true
    },
  },
}
</script>

<style scoped>
.href-select {
  color: #409eff;
  text-decoration: underline;
  font-family: 'Rubik Medium', sans-serif;
  font-size: 14px;
  cursor: pointer;
}
.href-select:hover {
  text-decoration: none;
}
.selected-contr {
  font-size: 14px !important;
  color: #b5b5b5;
  font-family: 'Rubik Medium', sans-serif;
}
</style>
